import { render } from "./RegOnTeam.vue?vue&type=template&id=65d58a36&scoped=true"
import script from "./RegOnTeam.vue?vue&type=script&lang=js"
export * from "./RegOnTeam.vue?vue&type=script&lang=js"

import "./RegOnTeam.vue?vue&type=style&index=0&id=65d58a36&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d58a36"]])

export default __exports__